import $ from 'jquery';
import screenSize from '../services/screen_size';

class BaseNav {
    constructor() {
        this.$window = $(window);
        this.scopedNavOpen = this.navOpen.bind(this);
        this.scopedNavClose = this.navClose.bind(this);
        this.$brandLogo = $('.brand-logo');
        this.$parentAnchor = this.$brandLogo.parent();
        this.oldHref = this.$parentAnchor.attr('href');
        this.oldLogo = this.$brandLogo.css('background-image');
        this.oldBgSize = this.$brandLogo.css('background-size');
    }

    changeLogo() {
        this.$parentAnchor.attr('href', 'http://fastcompany.com');
        this.$brandLogo.css({
            'background-image': 'url(//a.fastcompany.net/asset_files/-/2015/09/14/fastcompany-logo.svg)',
            'background-size': '100%'
        });
    }

    navOpen() {
        if (screenSize.getSize() === 'small') {
            this.changeLogo();
        }
    }

    navClose() {
        if (screenSize.getSize() === 'small') {
            this.$parentAnchor.attr('href', this.oldHref);
            this.$brandLogo.css({
                'background-image': this.oldLogo,
                'background-size': this.oldBgSize
            });
        }
    }

    navOpenOn() {
        this.$window.on('fc:hamburger:open', this.scopedNavOpen);
    }

    navOpenOff() {
        this.$window.off('fc:hamburger:open', this.scopedNavClose);
    }

    navCloseOn() {
        this.$window.on('fc:hamburger:close', this.scopedNavClose);
    }

    navCloseOff() {
        this.$window.off('fc:hamburger:close', this.scopedNavClose);
    }
}

export default BaseNav;
